<template>
	<div
    class="message-template-list"
    :class="{
      'px-2': scope === 'admin',
      'px-md-4': scope === 'admin',
      'py-2': scope === 'admin',
      'py-md-4': scope === 'admin',
    }"
  >
    <ConveyTable
      showSearch
      :showCreate="$auth.can('create:template')"
      tableClassName="message-template-table"
      :items="templates"
      :fields="scope === 'admin' ? adminFields : userFields"
      :placeholders="placeholders"
      :perPageOptions="perPageOptions"
      :perPage="perPage"
      :currentPage="currentPage"
      :totalRows="totalRows"
      :isLoading="isFetchingTemplates"
      @onFetch="(options) => fetchTemplates(options)"
      @onCreate="addTemplate"
    >
      <template #create-icon>
        <b-icon icon="journal-plus"></b-icon>
      </template>
      <template #create-label>
        Add Template
      </template>
      <template #cell(name)="data">
        <template v-if="data.item.type == 'agency' && scope == 'user'">
          {{ data.value }}
        </template>
        <template v-else>
          <router-link
            v-if="scope == 'admin' && $auth.can('read:template')"
            :to="`/admin/templates/${data.item.template_id}`"
          >
            {{ data.value }}
          </router-link>
          <a
            v-else-if="
              scope == 'user' && (
                $auth.can('read:currentuser:template')
                  || $auth.can('read:template')
              )
            "
            href="javascript:void()"
            @click.prevent="editTemplate(data.item.template_id)"
          >
            {{ data.value }}
          </a>
          <template v-else>{{ data.value }}</template>
        </template>
      </template>
      <template v-if="scope == 'user'" #cell(type)="data">
        <span class="text-capitalize">{{ data.value }}</span>
      </template>
    </ConveyTable>
	</div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import formatter from "@/mixins/formatter";
import errorHandler from "@/mixins/errorHandler";
import { EventBus } from "@/events/eventBus";
import TemplateDetail from "@/components/message_templates/TemplateDetail";
import ConveyTable from "@/components/ConveyTable";

export default {
	name: "TemplateList",
  mixins: [formatter, errorHandler],
  components: {
    ConveyTable,
  },
	props: {
		scope: {
			type: String,
			default: "user",
    },
	},
	data() {
		return {
      templates: [],
			isFetchingTemplates: false,
      perPage: 10,
      perPageOptions: [5, 10, 25, 50, 100],
      currentPage: 1,
      totalRows: 0,
      adminFields: [
        { key: "name", label: "Name", sortable: false },
        { key: "text", label: "Message", sortable: false },
      ],
      userFields: [
        { key: "name", label: "Name", sortable: false },
        { key: "type", label: "Type", sortable: false },
        { key: "text", label: "Message", sortable: false },
      ],
      placeholders: {
        search: "Search templates...",
      },
      fetchAbortController: null,
		};
	},
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
  },
	created() {
    EventBus.$on("refresh-templates", () => {
      this.fetchTemplates({
        currentPage: 1,
        perPage: this.perPage,
        searchKey: "",
      });
    });
	},
	methods: {
    abortFetchOperation() {
      if (this.fetchAbortController) {
        this.fetchAbortController.abort();
        this.fetchAbortController = null;
      }
    },
		async fetchTemplates(fetchOptions) {
			try {
        this.abortFetchOperation();
        this.fetchAbortController = new AbortController();
        const {
          perPage,
          currentPage,
          searchKey,
        } = fetchOptions;
				this.isFetchingTemplates = true;
        this.currentPage = currentPage;
        this.perPage = perPage;
				const offset = (currentPage - 1) * perPage;
        const params = {
          offset,
          limit: perPage,
        };
				if (searchKey) {
          params['search'] = searchKey;
        }

        let resp;
        if (this.scope === "admin") {
          resp = await this.$ConveyApi.templatesApi.getAgencyMessageTemplates({
            agencyId: this.currentAgencyId,
            params,
            signal: this.fetchAbortController.signal,
          });
        } else {
          resp = await this.$ConveyApi.templatesApi.getUserMessageTemplates({
            params,
            signal: this.fetchAbortController.signal,
          });
        }

        const { data, metadata } = resp.data;
        this.templates = data;
        this.totalRows = metadata ? metadata.totalRows || 0 : 0;
			} catch(err) {
        if (!this.isApiCanceled(err)) {
          console.log(err);
        }
			} finally {
        this.isFetchingTemplates = false;
      }
		},
		addTemplate() {
      if (this.scope === "user") {
        const $ = window.$;
        $("#id-modal-container").modal();
        EventBus.$emit("open", {
          component: TemplateDetail,
          title: "Create Message Template",
          props: {
            scope: "user",
          },
          closeOnClick: false,
        });
      } else if (this.scope === "admin") {
        this.$router.push({ name: "Admin Create Template" }).catch(() => {});
      }
		},
		editTemplate(templateId) {
			const $ = window.$;
			$("#id-modal-container").modal();
			EventBus.$emit("open", {
				component: TemplateDetail,
				title: "Edit Message Template",
				props: {
					scope: "user",
					templateId
				},
				closeOnClick: false,
			});
		},
	},
	beforeDestroy() {
		EventBus.$off("refresh-templates");
    this.abortFetchOperation();
	},
};
</script>

<style lang="scss">
.message-template-list {
  width: 100%;
  height: 100%;
}
</style>